import {Presentation} from "../../../../core/gameflow/controller/Presentation";
import {ArrayHelper} from "../../../../core/utils/ArrayHelper";
import {Helper} from "../../../../core/utils/Helper";
import {PunkRocker} from "../../../PunkRocker";
import {SoundConfig} from "../../../sound/SoundConfig";
import {SoundManager} from "../../../sound/SoundManager";
import {PREngineManager} from "../../../punkEngine/PREngineManager";
import {PunkSymbol} from "../../../punkEngine/symbol/PunkSymbol";
import {IAllWinData, IBetWayWinData} from "../../../server/base/IData";
import {GameData} from "../../../server/data/GameData";
import {InitData} from "../../../server/data/InitData";
import {NoWinPosterState, PosterManager} from "../../independent/Poster/PosterManager";
import {GameMode} from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';
import {gsap} from "gsap";

export class IdlePresentation extends Presentation {

    protected posterHit: boolean = false;
    protected posterCounter: number = 0;
    protected _noWinPosters: string[] = [NoWinPosterState.BOLLOCKS, NoWinPosterState.SHIT_GAME, NoWinPosterState.QUEEN]
    private featurePlayed: boolean = false;
    private respinFeature: boolean = false;
    private _gameData: GameData;
    private _idleTimeline: gsap.core.Timeline | null;
    private firstTrigger: boolean = true;
    private _allHits: IAllWinData;
    // protected _blowMyGame:gsap.core.Timeline;

    public onBeforeSpinStart(): void {
        if (this._idleTimeline) {
            PunkRocker.counter.remove();
            this._idleTimeline.pause();
            this._idleTimeline.kill();
            this._idleTimeline = null;
        }
    };

    public setInitData(data: InitData): void {
        this.firstTrigger = data.nextMode == GameMode.NORMAL;
        const arr: number[] = [0, 1, 2];
        ArrayHelper.shuffle(arr);
        let pp: string[] = [];

        for (let p: number = 0; p < arr.length; p++) {
            pp.push(this._noWinPosters[arr[p]])
        }
        this._noWinPosters = pp;
    }

    setGamedData(data: GameData): void {
        this.featurePlayed = (data.mode != GameMode.NORMAL && data.nextMode == GameMode.NORMAL);
        this.respinFeature = (data.mode == GameMode.RESPIN && data.nextMode == GameMode.NORMAL);
        this._gameData = data;
        this._allHits = data.Win.allBetWayWinData;

        if (data.Win.isBigWin || this.featurePlayed) {
            this.posterHit = false;
        }

        // if(data.Win.singleWin == 0){
        //     let wildCount:number = 0;
        //     let mysteryCount:number = 0;

        //     if(this.featurePlayed && data.mode == GameMode.RESPIN){
        //         this.posterHit = true;
        //     }
        //     else if(!this.featurePlayed && data.wildExpands){
        //         data.wildLandPositions.forEach(pos => {if(pos >= 0) wildCount++});
        //         if(wildCount >= 2) this.posterHit = true;
        //     }
        //     else if(!this.featurePlayed && data.mysteryData!.mysterySymbolAppeared){
        //         data.mysteryData!.mysterySymbolOnReel.forEach(lands => {if(lands) mysteryCount++});
        //         if(mysteryCount >= 3) this.posterHit = true;
        //     }
        //     else if(wildCount + mysteryCount >= 3){
        //         this.posterHit = true;
        //     }
        // }
    }

    public checkForActivation(data: GameData): boolean {
        return data.nextMode == GameMode.NORMAL && !data.raw.brokeTheBank;
    }

    // Check the condition at PresentationController Play();
    public createPresentation(): void {
        // if(this.firstTrigger){
        //     // SoundManager.reset();
        //     // PREngineManager.RAll((Reel:number) => ReelSlicedDivider.instance.addDividers(false,Reel));
        //     // this.firstTrigger = false;
        //     return;
        // }

        this.timeline.add(() => PosterManager.instance.playSiren(false));

        // if(!this.featurePlayed) ReelAnimationManager.bonusReel.IdleEnabling();
        // else SoundManager.reset();

        // if(this.posterHit) this.playNoWin();
        if (this._gameData.Win.betWayWins.length > 0) {
            this.addWinCountUpToTimeline();
        } else {
            PunkRocker.background.changeGraphicAlpha(0.3, 0);
        }

        this.PresentationState.setInactive();
    }

    public endPresentation(): void {
        if (this.featurePlayed) {
            if (!this.respinFeature) {
                SoundManager.playSoundEffect(SoundConfig.WILD_MOVES);
                // for(let jw:number = 0; jw < JumpingWildController.instance.items.length; jw++){
                //     this.timeline.add(JumpingWildController.instance.JumpTo({
                //         ID: jw,
                //         to:{reel: ReelAnimationManager.bonusReel.ReelID, row: jw%PREngineManager.getReel(5).AllWindowSymbols.length },
                //         duration:0.6,
                //         state: JumpWildState.IDLE
                //     }),0)
                // }
                PunkRocker.waysCounter.totalWinMorse(0.5, false);
            }
            // this.timeline.add(ReelAnimationManager.bonusReel.playEnd());
        }

        PunkRocker.waysCounter.setValue(undefined, Math.pow(3, 6), 0.4);
        PunkRocker.waysCounter.stopLoop();

        if (this._idleTimeline) {
            this._idleTimeline = Helper.setTimeline(this._idleTimeline);
            // WinCounter.winWayCounter.updateWinWays(this._allHits.totalWinCombination);
            // WinCounter.normalCounter.abort(this._gameData!.singleWin);
        }

        // PREngineManager.RSWindow((reel,sym:PunkSymbol) => {sym.setVisibleForSymbol(true);})
        // ReelAnimationManager.bonusReel.IdleDisabling();
        PunkRocker.background.changeGraphicAlpha(0.3, 0);
        // this.PresentationState.set(PresentationState.INACTIVE);
    }

    protected playNoWin(): void {
        this.posterHit = false;
        PosterManager.instance.play(NoWinPosterState.NO_WIN, {animation: this._noWinPosters[this.posterCounter]});
        this.posterCounter++;
        this.posterCounter = this.posterCounter % this._noWinPosters.length;
        this.timeline.to(this, {
            duration: 0.750
        });
    }

    protected addWinCountUpToTimeline(): void {
        if (this._gameData.Win.isWinBelowStake!()) {
            return;
        }

        this._idleTimeline = new gsap.core.Timeline({
            repeat: -1,
            repeatDelay: 0,
            delay: 1.5
        });

        const delay: number = 0.5,
            durr: number = 1.2;

        for (let groups: number = 0; groups < this._gameData.Win.betWayWins.length; groups++) {
            const winData: IBetWayWinData = this._gameData.Win.betWayWins[groups];
            for (let reel: number = 0; reel < winData.reelWinPositions.length; reel++) {
                let posRow: boolean[] = winData.reelWinPositions[reel];
                for (let row: number = 0; row < posRow.length; row++) {
                    const sym: PunkSymbol | undefined = PREngineManager.getReel(reel).getSymbol(row);
                    this._idleTimeline.add(() => {
                        if (posRow[row]) {
                            sym?.markNonWin(false);
                            sym?.playWin(true, durr, winData.numberOfCombinations);
                            PunkRocker.counter.play(winData.amount, winData.amount, 0.001, winData.numberOfCombinations, true);
                            PunkRocker.counter.showWays(0.001, true);
                        } else {
                            sym?.markNonWin(true);
                        }
                    }, (delay + (groups * durr)));
                }
            }

            this._idleTimeline.add([
                () => {
                    this.removeSymFrames(0.5, true);
                }
            ], ((delay + (groups * durr)) + durr));
        }


        /*if (this._gameData.Win.isWinBelowStake!()) {
            return;
        }
        //StateSymbolWin.instance.resetIdleTimeline();

        this._idleTimeline = new gsap.core.Timeline({
            repeat: -1,
            repeatDelay: 0
        });

        const delay: number = 2,
            durr: number = 1.2;

        this._idleTimeline.to(this, {
            duration: 2
        });

        //this._idleTimeline.fromTo(ReelGraphicBackground.instance,duration*0.2,{alpha:0},{alpha:0.5},delay);
        //this._idleTimeline.add(() => WinCounter.normalCounter.alpha = 1, delay)

        for (let groups: number = 0; groups < this._gameData.Win.betWayWins.length; groups++) {
            const winData: IBetWayWinData = this._gameData.Win.betWayWins[groups];
            for (let reel: number = 0; reel < winData.reelWinPositions.length; reel++) {
                let posRow: boolean[] = winData.reelWinPositions[reel];
                for (let row: number = 0; row < posRow.length; row++) {
                    const sym: PunkSymbol | undefined = PREngineManager.getReel(reel).getSymbol(row);
                    this._idleTimeline.add(() => {
                        if (posRow[row]) {
                            sym?.markNonWin(false);
                            sym?.playWin(true, durr, winData.numberOfCombinations);
                        } else {
                            sym?.markNonWin(true);
                        }
                    }, (delay + (groups * durr)));
                }
            }

            this._idleTimeline.add([
                () => {
                    PunkRocker.counter.play(winData.amount, winData.amount, 0.001, winData.numberOfCombinations, true);
                },
                () => {
                    PunkRocker.counter.showWays(0.001, true);
                }
            ], delay + (groups * durr));

            this._idleTimeline.add([
                () => {
                    this.removeSymFrames(0.5, true);
                }
            ], ((delay + (groups * durr)) + durr));
        }

        if (this._gameData.Win.betWayWins.length > 1) {
            const reelWinPositions: boolean[][] = this._gameData.Win.allBetWayWinData.reelWinPositions;
            for (let reel: number = 0; reel < reelWinPositions.length; reel++) {
                for (let row: number = 0; row < reelWinPositions[reel].length; row++) {
                    const sym: PunkSymbol | undefined = PREngineManager.getReel(reel).getSymbol(row);
                    this._idleTimeline.add(() => {
                        if (reelWinPositions[reel][row]) {
                            sym?.markNonWin(false);
                            sym?.playWin(true, durr, this._gameData.Win.allBetWayWinData.biggestWinLvl);
                        } else {
                            sym?.markNonWin(true);
                        }
                    }, (delay + (this._gameData.Win.betWayWins.length * durr)));
                }
            }
        }

        this._idleTimeline.add([
            () => {
                PunkRocker.counter.play(this._gameData.Win.singleWin, this._gameData.Win.singleWin, 0.001, this._gameData.Win.allBetWayWinData.totalWinCombination);
            },
            () => {
                PunkRocker.counter.showWays(0.001, true);
            }
        ], delay + (this._gameData.Win.betWayWins.length * durr));

        //this._idleTimeline.add(() => WinCounter.normalCounter.abort(this._gameData.singleWin),"+=0.3");
        let totalDurr: number = this._idleTimeline.duration();

        this._idleTimeline.add([
            () => {
                this.removeSymFrames(0.5, true);
            }
        ], (delay + (this._gameData.Win.betWayWins.length * durr) + durr));

        //this._idleTimeline.to(ReelGraphicBackground.instance, 0.3,{alpha:0},totalDurr-(duration*0.4));
        this._idleTimeline.play();*/
    }

    private removeSymFrames(duration: number, ignoreDarknessChange?: boolean): void {
        PREngineManager.RSAll((rc, sym) => {
            sym.stopWin(duration, ignoreDarknessChange);
        });
    }
}